"use client";

import { useRef } from "react";
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselSlide } from "@mantine/carousel";
export default function ProductSlideImageCarousel({
  items = [],
  renderItem,
  autoplayDelay = 3000,
  slideSize = {
    base: "50%",
    sm: "33.33%",
    md: "25%",
    lg: "20%",
    xl: "20%"
  }
}) {
  const autoplay = useRef(Autoplay({
    delay: autoplayDelay,
    stopOnInteraction: true
  }));
  return <Carousel withIndicators={false} previousControlProps={{
    "aria-label": "Previous"
  }} nextControlProps={{
    "aria-label": "Next"
  }} slideGap="sm" slideSize={slideSize}
  // eslint-disable-next-line react-hooks/refs
  plugins={[autoplay.current]}
  // eslint-enable-next-line react-hooks/refs
  emblaOptions={{
    loop: true,
    align: "start",
    slidesToScroll: 1
  }} styles={{
    control: {
      pointerEvents: "all",
      background: "white",
      color: "black",
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
    }
  }}>
            {items?.map((item, index) => <CarouselSlide key={index} py="xs">
                    {renderItem(item)}
                </CarouselSlide>)}
        </Carousel>;
}